import styled from 'styled-components';
import Checkbox from '../../../../../../components/Checkbox';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 15px;

  & .main-icon {
    width: 112px;
  }

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }
`;

export const CloseWrapper = styled.div`
  margin-top: 16px;

  & div {
    display: flex;
    gap: 8px;
    cursor: pointer;
  }
`;

export const CloseIcon = styled.img`
  cursor: pointer;
`;

export const CloseTitle = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: #555658;
`;

export const CheckWrapper = styled.div`
  padding-top: 20px;
`;

export const CustomCheck = styled(Checkbox)`
  display: flex;
  justify-content: center;
  cursor: pointer;
  gap: 14px;
  align-items: center;
`;
